<template>
  <LvFlexBox v-if="duration !== null" noWrap gap8 alignItems="center" class="lv-duration-range">
    <ContentChip
      bold
      noWrap
      :isI18n="false"
      :textLabel="`${duration} ${$t('分')}`"
      class="lv-duration-range__chip"
    />
    <LvText h5 noWrap lightGray textAlign="right" class="lv-duration-range__range">
      {{ _rangeText }}
    </LvText>
  </LvFlexBox>
</template>

<script>
import H_time from '@/helpers/time';

export default {
  props: {
    duration: {
      type: Number,
      default: null,
    },
    startAt: {
      type: String,
      default: '',
    },
    endAt: {
      type: String,
      default: '',
    },
  },
  computed: {
    _rangeText() {
      if (!this.startAt || !this.endAt) return '';
      const start = H_time.getDateDashFormat(this.startAt, 'HH:mm');
      const end = H_time.getDateDashFormat(this.endAt, 'HH:mm');
      return `${start} ~ ${end}`;
    },
  },
};
</script>
